import React, { Component } from "react";
// import moment from "moment";
// import errorFunctions from "../../../store/errorFunctions";
import { MdClose } from "react-icons/md";
import Modal from "react-modal";
import axios from "axios";
import config from "../../../config";
import utilityFunctions from "../../../store/utilityFunctions";

export default class Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      warranties: [],
      notes: [],
      statusFilter: "All",
      searchFilter: "",
      showAddNote: false,
      addedNote: "",
      editedNote: "",
      editedNoteId: "",
    };
  }

  // componentDidMount() {
  //   this.retrieveCustomerNotes(this.props.customerId);
  // }

  handleInputChange = (e) => {
    const { id, value } = e.target;

    this.setState({
      [id]: value,
    });
  };
  handleAddNote = (e) => {
    this.setState({ loading: true, showAddNote: false });
    e.preventDefault();
    // let formData = new FormData();
    // formData.append("note", e.currentTarget.addedNote.value);
    this.addNote({ note: e.currentTarget.addedNote.value }, this.state.id);

    console.log(this.state.warranties);
  };

  addNote(data) {
    const token = utilityFunctions.getAccessToken();
    let options = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    const url = `${config.backendServer}service_center/${this.props.serviceCenterId}/note/`;
    axios
      .post(url, data, options)
      .then(() => {
        this.setState({
          addedNote: "",
          editedNoteId: "",
          editedNote: null,
        });
        this.props.retrieveServiceCenter(this.props.serviceCenterId);
      })
      .catch((error) => {
        // Handle the error or show an error message
        alert(error?.response?.data?.non_field_errors?.[0] || error?.response?.data?.serial_number?.[0] || "Something went wrong.. try later");
        this.setState({ isLoading: false });
      });
  }

  render() {
    // const that = this;
    // const userInfo = utilityFunctions.getCookie("userInfo");
    return (
      <div className={"activity-wrapper"}>
        <div style={{ margin: "10px" }}>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => {
              this.setState({
                showAddNote: true,
                editedNoteId: "",
                editedNote: null,
              });
            }}
          >
            Add Note
          </button>
        </div>
        {/* <h4 className={"single-warranty-header"}>activities and comments</h4> */}
        <ul style={{ padding: "0px" }}>
          {this.props.data
            .sort((a, b) => {
              return b.id - a.id;
            })
            .map(function (item, i) {
              return (
                <div key={i} className="card" style={{ marginBottom: "10px" }}>
                  <div>
                    <div style={{ margin: "1px" }} className={"card-note-title row"}>
                      <div className="col-8">{`Note by ${item.created_by}`}</div>
                    </div>
                    <div className="card-body">
                      <p className="card-text">{item.note}</p>
                      <p className="card-text">{item.created_by}</p>
                    </div>
                  </div>
                </div>
              );
            })}
        </ul>
        <Modal
          isOpen={this.state.showAddNote}
          //onRequestClose={()=>this.setState({showDeclineModal: false})}
          contentLabel={"Add Note"}
          className={"input-modal"}
        >
          <div className="card">
            <button onClick={() => this.setState({ showAddNote: false })} className={"confirm-modal-close"}>
              <MdClose />
            </button>
            <div className="card-header">{this.state.editedNote ? "Edit" : "Add"} Note</div>
            <form onSubmit={this.handleAddNote}>
              <div className={"card-body"}>
                <textarea
                  required={true}
                  onChange={this.handleInputChange}
                  id={"addedNote"}
                  className="form-control w-100"
                  value={this.state.addedNote || this.state.editedNote}
                />
              </div>
              <div className={"card-footer"}>
                <button type="submit" className={"btn btn-outline-primary mr-3"}>
                  Save
                </button>
                <button type={"button"} className={"btn btn-outline-secondary"} onClick={() => this.setState({ showAddNote: false, addedNote: "" })}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    );
  }
}
